import { classes } from 'html-classes';

import { company } from '~/company/Company';
import { ProductCardSkeletonProps } from '~/components/ProductCardV3/skeletons/types';

import styles from './ProductCardSkeletonM.module.scss';

/**
 * ProductCardSkeletonM - Loading skeleton for ProductCardM
 * Mirrors ProductCardM layout: fluid width (grid stretches to column),
 * square image (aspect-ratio 1/1) and content-driven height
 */
const ProductCardSkeletonM = ({ className }: ProductCardSkeletonProps) => {
  return (
    <div
      className={classes([styles.skeleton, className])}
      data-company={company.name}
    >
      {/* Image skeleton with favorite icon */}
      <div className={styles.imageWrapper}>
        <div className={styles.imageSkeleton}>
          <div className={styles.favoriteIcon} />
        </div>
      </div>

      {/* Info section skeleton */}
      <div className={styles.infoWrapper}>
        {/* Name section */}
        <div className={styles.nameSection}>
          <div className={styles.nameLine} />
          <div className={classes([styles.nameLine, styles.nameLine_short])} />
        </div>

        {/* Rating and volume section */}
        <div className={styles.volumeLine} />

        {/* Price and button section */}
        <div className={styles.bottomSection}>
          <div className={styles.priceColumn}>
            <div className={styles.priceLine} />
            <div className={styles.discountLine} />
          </div>
          <div className={styles.buttonSkeleton} />
        </div>
      </div>
    </div>
  );
};

export default ProductCardSkeletonM;
